export * from './jurnals.component';